<script lang="ts" module>
  import { DropdownMenu } from 'bits-ui';

  import type { IconName } from '@/ui/base';
  import CTAButton from '@/ui/elements/buttons/CTAButton.svelte';

  export interface AICardHeaderActionItem {
    id: string;
    label: string;
    onclick: (item: AICardHeaderActionItem) => void;
    disabled: boolean;
    icon?: IconName;
  }

  export type AICardHeaderActionDropdownProps = {
    actions: AICardHeaderActionItem[];
    label: string;
    disabled?: boolean;
  };
</script>

<script lang="ts">
  import Icon from '@/ui/base/icon/Icon.svelte';

  // import { useDynamicConfig } from '@/ui/state/use-core-state.svelte';

  let { actions, label, disabled }: AICardHeaderActionDropdownProps = $props();
  let open = $state(false);
  // const dynamicConfig = useDynamicConfig();
  // let standardMenu = $derived($dynamicConfig.testFeaturesEnabled);
</script>

<DropdownMenu.Root bind:open>
  <DropdownMenu.Trigger class="select-none"
    >{#snippet child({ props })}
      <CTAButton
        variant="primary"
        icon={open ? 'KeyboardDoubleArrowUp' : 'KeyboardArrowDown'}
        {...props}
        {disabled}>{label}</CTAButton
      >
    {/snippet}
  </DropdownMenu.Trigger>
  <!-- {#if standardMenu} -->
  <DropdownMenu.Portal>
    <DropdownMenu.Content
      align="end"
      sideOffset={4}
      class="z-[70] grid gap-1 rounded-sm bg-dropdown-S p-1"
    >
      {#each actions as action (action.id)}
        <DropdownMenu.Item
          class="fr w-full items-center justify-end gap-2 rounded-xs p-1 font-sans text-sm {(
            action.disabled
          ) ?
            'cursor-default text-c-disabled hocus:bg-transparent'
          : 'cursor-pointer bg-select-dropdown font-normal text-c-base hocus:bg-select-dropdown-H'}"
          disabled={action.disabled}
          onSelect={() => action.onclick(action)}
        >
          {action.label}
          {#if action.icon}
            <Icon icon={action.icon} size={4} />
          {/if}
        </DropdownMenu.Item>
      {/each}
    </DropdownMenu.Content>
  </DropdownMenu.Portal>
  <!-- {:else}
    <DropdownMenu.Portal>
      <DropdownMenu.Content
        align="center"
        sideOffset={4}
        class="z-[70] flex min-w-[var(--bits-floating-anchor-width)] select-none flex-col gap-2 rounded-sm bg-plain p-2 shadow-card"
      >
        {#each actions as action (action.id)}
          <DropdownMenu.Item disabled={action.disabled}>
            <CTAButton
              variant="primary"
              class="w-full"
              disabled={action.disabled}
              icon={action.icon}
              onclick={() => action.onclick(action)}>{action.label}</CTAButton
            >
          </DropdownMenu.Item>
        {/each}
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  {/if} -->
</DropdownMenu.Root>
